module.exports = __webpack_public_path__ + "img/mobile_map_brindisi.25ce32fb.svg";